export default __webpack_public_path__ + "static/media/isologo.d2ee46a0.svg";